import React from 'react';
import styled from 'styled-components';
import {
  outlineCircleSlideDown,
  outlineCircleSlideUp,
} from '../../../../../../../common/src/utils/cssAnimationsUtils';
import { mqh } from '../../../../../../../common/src/utils/styledComponentsUtils';
import OffersSidebarPriceSummaryContainer from './OffersSidebarPriceSummaryContainer';

interface Props {
  show?: boolean;
}

const OffersSidebarPriceSummary: React.FC<React.PropsWithChildren<Props>> = ({
  show,
}) => {
  return (
    <PriceSummary show={show}>
      <Container show={show}>
        <OffersSidebarPriceSummaryContainer />
      </Container>
    </PriceSummary>
  );
};

const roundedCorner = `
position: absolute;
content: '';
width: 60px;
height: 60px;
right: 0;
`;

const Container = styled.div<{ show?: boolean }>`
  display: none;

  ${mqh.hd} {
    display: block;

    border-radius: 6px;
    background-color: white;
    position: relative;
    margin: 32px 0;
    height: calc(100% - 60px); /* Height minus margins  */
    color: ${({ theme }) => theme.labels.guaranteeText};

    &::before {
      ${roundedCorner}
      background-color: ${({ theme }) =>
        theme['isImmo'] ? theme.secondary[700] : theme.secondary[800]};
      box-shadow: 0.1px 30px 0 0 #fdfcff;
      bottom: 100%;
      border-bottom-right-radius: 30px;
      animation: ${outlineCircleSlideUp} 0.3s;
      animation-fill-mode: forwards;
      opacity: 0;
      z-index: -1;
      transform-origin: bottom;
      transform: ${({ show }) => !show && 'scaleY(0)'};
      transition: 0.3s;
    }
    &::after {
      ${roundedCorner}
      background-color: ${({ theme }) =>
        theme['isImmo'] ? theme.secondary[700] : theme.secondary[800]};
      top: 100%;
      box-shadow: 0.1px -30px 0 0 #fdfcff;
      border-top-right-radius: 30px;
      animation: ${outlineCircleSlideDown} 0.3s;
      animation-fill-mode: forwards;
      opacity: 0;
      z-index: -1;
      transform-origin: top;
      transform: ${({ show }) => !show && 'scaleY(0)'};
      transition: 0.3s;
    }
  }
`;

const PriceSummary = styled.div<{ show?: boolean }>`
  width: 100%;
  transition: 0.3s;
  max-height: 100%;
  max-height: ${({ show }) => !show && '0'};
  overflow: hidden;
`;

export default OffersSidebarPriceSummary;
